'use strict';

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function IconEnvelope(props) {
    return (React__namespace.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React__namespace.createElement("path", { d: "M3.414 5L12 13.586 20.586 5H3.414zM2 19h20V6.414l-9.293 9.293a.999.999 0 01-1.414 0L2 6.414V19zm21 2H1a1 1 0 01-1-1V3.997a.988.988 0 01.293-.704A1.009 1.009 0 01.997 3h22.006a.988.988 0 01.704.293.983.983 0 01.293.704V20a1 1 0 01-1 1z" })));
}

module.exports = IconEnvelope;
